
// export const getProductDetails = async
import {QUERY_KEYS} from '~/utils/services/keys';
import type {
    IProductDetails,
} from '~/utils/services/api';
import {
    getProductDetails,
    getProductWishlists,
    getWarrantySupplier,
} from '~/utils/services/api';
import type {AsyncDataOptions} from '#app';

export const useProductDetails = (id: string, options: AsyncDataOptions<IProductDetails, any> = {}) => {
    return useAsyncData(QUERY_KEYS.article.details(id), () => {
        if (id) return getProductDetails(id);
        return rejectQueryFn();
    }, options);
};

export const useProductWishlist = (id: string, server = true) => {
    const {userId} = useCpUser();
    return useAsyncData(QUERY_KEYS.article.wishlists(id), () => {
        // We need a user logged in to make this request
        if (userId) {
            return getProductWishlists(id);
        }
        return rejectQueryFn();
    }, {server});
};

export const useUpdateWishlistInfo = async (urlId: string, server = true) => {
  const product = await useProductWishlist(urlId, server);
  const wishlists = await useWishlists(server);
  return [product, wishlists];
};

export const useGetWarrantySupplier = async (articleId: string) => {
    return await getWarrantySupplier(articleId);
};
